// Invio dei report di errore all'amministratore del servizio.
//
// Due modalità, stesso canale (backend /report-error → email ad
// ERROR_ALERT_EMAIL, con gli stessi freni degli avvisi 500):
//
//   manuale    - l'utente preme "Invia report" nel modale d'errore;
//   automatico - un errore i cui dettagli non hanno senso per l'utente
//                (tipicamente un 403): lui vede un messaggio generico con un
//                codice di riferimento, noi riceviamo il report completo.
//
// Su gestionale-gls il canale è una Netlify Function; qui è il backend, così
// funziona anche offline.

import { API_URL } from "../config/app";
import { getUserInfo, ID_AZIENDA_KEY, TOKEN_KEY } from "./storageKeys";
import packageInfo from "../../package.json";

export function newReferenceCode() {
  return Math.random().toString(36).slice(2, 8).toUpperCase();
}

export async function sendErrorReport({ modalText, errorData = null, apiError = null, reference = null, kind = "manuale" }) {
  const { email } = getUserInfo();
  const token = localStorage.getItem(TOKEN_KEY);
  const res = await fetch(`${API_URL}/report-error`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...(token ? { Authorization: token } : {}) },
    body: JSON.stringify({
      userEmail: email,
      companyId: localStorage.getItem(ID_AZIENDA_KEY) || "",
      page: window.location.href,
      errorMessage: modalText || "Nessun messaggio di errore",
      errorData,
      apiError,
      reference,
      kind,
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString(),
      appVersion: packageInfo.version,
    }),
  });
  if (!res.ok) throw new Error("Invio fallito");
}

// Freni dei report automatici: stessa firma = un solo invio (si riusa il
// codice), e un tetto per sessione.
const MAX_AUTO_REPORTS_PER_SESSION = 8;
const sentReferences = new Map();
let autoReportCount = 0;

export function autoReportError({ signature = null, modalText, errorData = null, apiError = null }) {
  if (signature && sentReferences.has(signature)) return sentReferences.get(signature);
  if (autoReportCount >= MAX_AUTO_REPORTS_PER_SESSION) return null;
  const reference = newReferenceCode();
  autoReportCount += 1;
  if (signature) sentReferences.set(signature, reference);
  sendErrorReport({ modalText, errorData, apiError, reference, kind: "automatico" }).catch(() => {});
  return reference;
}
